/* ==========================================================================
   Koolseed — Öngörülü arama
   Shopify Predictive Search API. JS yoksa form normal arama sayfasına gider.
   ========================================================================== */

(function () {
  'use strict';

  const MIN_CHARS = 2;

  class KsPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('#ks-search-results');
      if (!this.input || !this.results) return;

      this.controller = null;
      this.onInput = window.KS.debounce(this.search.bind(this), 250);

      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.results.addEventListener('click', () => this.close());
    }

    async search() {
      const term = this.input.value.trim();

      if (term.length < MIN_CHARS) {
        this.close();
        return;
      }

      // Önceki isteği iptal et; yavaş yanıt yeni sonucun üstüne yazmasın.
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      this.setBusy(true);

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,article,page',
        'resources[limit]': '5',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
      });
      const url = `${window.KS_ROUTES.predictive_search}?${params}&section_id=ks-predictive-search`;

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('search failed');

        const html = await response.text();
        const fresh = window.KS.extract(html, '#ks-predictive-results');

        this.results.innerHTML = fresh ? fresh.innerHTML : '';
        this.open();
      } catch (error) {
        if (error.name === 'AbortError') return;
        // Ağ hatasında sessizce kapan; kullanıcı formu gönderebilir.
        this.close();
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      this.results.setAttribute('aria-busy', String(busy));
      this.classList.toggle('is-loading', busy);
    }

    open() {
      this.results.classList.add('is-open');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.classList.remove('is-open');
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        if (this.results.classList.contains('is-open')) {
          event.stopPropagation();
          this.close();
        }
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      const items = Array.from(this.results.querySelectorAll('a'));
      if (!items.length) return;
      event.preventDefault();

      const current = items.indexOf(document.activeElement);
      const step = event.key === 'ArrowDown' ? 1 : -1;
      const next = (current + step + items.length) % items.length;
      items[next].focus();
    }
  }

  if (!customElements.get('ks-predictive-search')) {
    customElements.define('ks-predictive-search', KsPredictiveSearch);
  }
})();
